import { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';
import { supabase } from '@/lib/supabaseClient';

export function usePlazasDisponibles(
  idServicio: string | null,
  fecha: string | null,
  hora: string | null,
  clienteMax?: number
) {
  const [plazas, setPlazas] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      if (!idServicio || !fecha || !hora) {
        if (!cancelled) setPlazas(null);
        return;
      }

      const { data, error } = await supabase
        .from('vista_plazas_disponibles')
        .select('plazas_disponibles')
        .eq('id_servicio', idServicio)
        .eq('fecha_cita', fecha)
        .eq('hora_cita', hora)
        .maybeSingle();

      if (error) {
        Sentry.captureException(error, { extra: { idServicio, fecha, hora } }); // 👈
        if (!cancelled) setPlazas(null);
        return;
      }

      if (!cancelled) {
        setPlazas(data?.plazas_disponibles ?? clienteMax ?? null);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [idServicio, fecha, hora, clienteMax]);

  return plazas;
}
